import React from 'react';
import { formatNumber } from '../../utils/number';
import styles from './vertical-exaggeration-slider.module.scss';

interface VerticalExaggerationSliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

const VerticalExaggerationSlider = ({
  value,
  onChange,
  min = 1,
  max = 10,
  step = 0.1,
}: VerticalExaggerationSliderProps) => {
  const fillPct = ((value - min) / (max - min)) * 100;

  return (
    <div className={styles.control}>
      <div className={styles.header}>
        <span className={styles.title}>Vertical Exaggeration</span>
        <span className={styles.value}>{formatNumber(value, 1, 1)}×</span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className={styles.slider}
        style={{ '--ve-fill': `${fillPct}%` } as React.CSSProperties}
      />
    </div>
  );
};

export { VerticalExaggerationSlider };
